import Raven from 'raven-js';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFullTrack } from '../../tracks';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import { useMostRecentExamAttempt } from '../examsQueries';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamAwardNotGeneratedScreen = ({
  trackId,
  language
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  useEffect(() => {
    if (trackId && mostRecentExamAttempt) {
      Raven.captureMessage('Award failed to generate', {
        extra: {
          examAttemptId: mostRecentExamAttempt && mostRecentExamAttempt.id,
          trackId
        }
      });
      Metrics.counter('award-failed-to-generate').increment();
    }
  }, [mostRecentExamAttempt, trackId]);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    error: trackError || mostRecentExamAttemptError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.awardNotGeneratedHeader"
    }),
    illustration: "announcement",
    language: language,
    loading: trackLoading || mostRecentExamAttemptLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.awardNotGenerated",
      options: {
        courseName: track && track.name
      }
    }),
    trackId: trackId
  });
};
export default ExamAwardNotGeneratedScreen;